import yup from "config/yup"
import { UpdateDepositNameValues } from "./UpdateDepositName.types"

export const updateDepositNameSchema: yup.SchemaOf<UpdateDepositNameValues> =
  yup.object().shape({
    depositName: yup.string().required(),
  })
